<template>
  <AppLayout>
    <div class="transaction">
      <section id="transaction-products">
        <div class="container">
  
          <h6 class="fw-bold">Reserved Stock</h6>
  
          <div class="filter-search" style="margin-top: 0px; padding-left: 0px">
            <div class="filter-search-header">
              <p>Filter</p>
              <p class="clear" @click="clear">Clear</p>
            </div>
            <div class="filter-search-body">
              <div class="form">
                <div class="row">
                  <div class="col-md-2 align-self-end">
                    <div class="form-group">
                      <label for="date">Date From</label>
                      <input type="date" class="form-control" v-model="dateFrom" @change="filterTable"  />
                    </div>
                  </div>
                  <div class="col-md-2 align-self-end">
                    <div class="form-group">
                      <label for="date">Date To</label>
                      <input type="date" class="form-control" v-model="dateTo" @change="filterTable" />
                    </div>
                  </div>

                </div>
              </div>
            </div>
          </div>
  
          <div class="products-list transaction-products-list" style="margin-top: 0px;">
        
            <!-- Skeleton loader for reserved stock table -->
            <SkeletonLoader v-if="loading" type="table" :rows="8" :columns="8" />
            
            <keep-alive v-else>
              <table class="table table-hover" id="reservedTable">
                <thead>
                  <th style="background-color: #f8f9fa; font-size: 11px; font-weight: 600; padding: 15px 8px; text-align: left;">No.</th>
                  <th style="background-color: #f8f9fa; font-size: 11px; font-weight: 600; padding: 15px 8px; text-align: left;">Date </th>
                  <th style="background-color: #f8f9fa; font-size: 11px; font-weight: 600; padding: 15px 8px; text-align: left;">Product Description</th>
                  <th style="background-color: #f8f9fa; font-size: 11px; font-weight: 600; padding: 15px 8px; text-align: left;">Qty Reserved</th>
                  <th style="background-color: #f8f9fa; font-size: 11px; font-weight: 600; padding: 15px 8px; text-align: left;">Reserved By</th>
                  <th style="background-color: #f8f9fa; font-size: 11px; font-weight: 600; padding: 15px 8px; text-align: left;">Released Date</th>
                  <th style="background-color: #f8f9fa; font-size: 11px; font-weight: 600; padding: 15px 8px; text-align: left;">Warehouse</th>
                  <th style="background-color: #f8f9fa; font-size: 11px; font-weight: 600; padding: 15px 8px; text-align: left;">Action</th>
                </thead>
              </table>
            </keep-alive>
            <!-- <LoaderItem v-if="loading"/> -->
            <div v-if="activities.length < 1">
              <!--<label for="" class="alert alert-danger" style="margin: 0px auto; width: fit-content; display: block;">No log found</label>-->
            </div>
          </div>
        </div>
      </section>

    <Modal v-if="isVisible" @close="closeModal" >
      <template v-slot:header>
        <h4 class="text-primary fw-bold">Release Reserved Stock {{ !releaseStock? 'Request' : ''}} </h4>
      </template>

      <template v-slot:body>
        <div class="row">
          <div class="col-sm-12 mt-1">
            <div class="form-group">
              <label for="item-code">Priority</label>
              <select v-model="priority" class="col-7 full" id="priorities">
                  <option value="urgent">Urgent</option>
                  <option value="high">High</option>
                  <option value="normal">Normal</option>
              </select>
            </div>
              
          </div>
          <div class="form-group col-12">
            <label for="item-code">Quantity to Release</label>
            <input type="number" min="0" class="form-control" v-model="quantity">
          </div>
          <div class="form-group col-12">
            <label for="item-code">Comment</label>
            <input type="text" class="form-control" v-model="comment">
          </div>
        </div>
      </template>

      <template v-slot:footer>
        <button class="btn-style small" style="border: 1px solid black; float: right;" @click="confirmRelease">Confirm</button>
        <button class="btn btn-default" style="border: 1px solid black; float: right; margin-right: 10px;" @click="isVisible =false">Cancel</button>
      </template>
    </Modal>
    </div>
  </AppLayout>  
  </template>
  
  <script>
  
  import { mapGetters, mapActions } from 'vuex'
  import Swal from 'sweetalert2'
  import SkeletonLoader from '../../components/SkeletonLoader'
  import AppLayout from '../../components/AppLayout.vue';
  import Modal from '../../components/Modal.vue'
  import 'datatables.net-vue3';
  import 'datatables.net-bs5';
  import "datatables.net-buttons-bs5";
  import "datatables.net-responsive-bs5";
  import $ from 'jquery';
  import 'jszip';
  import 'datatables.net-buttons/js/buttons.html5.js';
  import 'datatables.net-buttons/js/buttons.html5.js';
  import 'datatables.net-buttons/js/buttons.colVis.js';
  import 'datatables.net-buttons/js/buttons.print.js';
  import { docFooter } from '@/utils/common';

  export default {
    name: 'StockReserveds',
    components: {
      AppLayout,
      Modal, 
      SkeletonLoader
    },
    data: () => ({
        token: JSON.parse(localStorage.getItem('access_token')),
        userId: JSON.parse(localStorage.getItem('userId')),
        dateFrom: "",
        dateTo: "",
        activities: [],
        activitiesDatas: [],
        isVisible:false,
        priority:"",
        quantity: "",
        comment: "",
        reservedId: "",
        dataTable:  null,
        processedData: [], 
        loading: false,
        releaseStock: false
    }),
    computed:{
        ... mapGetters (["getUsers"]),
        users () { return this.getUsers },
    },
    mounted(){
        this.getActivities(),
        this.fetchUsers()

        window.openModal = this.openModal;
    },
    methods:{
        ... mapActions(['fetchUsers']),  
        
        closeModal() {
          this.isVisible = false;
        }, 
        openModal(itemId, requesterId){
            if(requesterId == this.userId)
              this.releaseStock = true
            else
              this.releaseStock = false
            
            this.isVisible =true,
            this.reservedId = itemId
        },
      preprocessData(rawData) {
        return rawData.map(item => {
          return {
            indexNo:"1",
            createdAt: this.formatDate(item.createdAt, "true"),
            productName: item.Product.name,
            quantity: this.formatQty(item.quantity),
            userName: item.User?.name,
            approveDate: this.formatDate(item.Approval?.updatedAt),
            warehouse: item.Inventory.Warehouse.name,
            action: '',
            statusRow: item.status,
            itemId: item.id,
            requesterId: item.User?.id
          };
        });
      },

      reinitializeTable(){
          this.dataTable.clear()
          this.dataTable.rows.add(this.preprocessData(this.activitiesDatas))
          this.dataTable.draw()
      },

      clear(){
        this.dateFrom = ""
        this.dateTo = " "
        this.reinitializeTable()
      }, 

      initializeDataTable() {
        try{
          // Check if table element exists
          const tableElement = $(this.$el).find('#reservedTable');
          if (tableElement.length === 0) {
            console.warn('Table element #reservedTable not found');
            return;
          }
          
          this.dataTable = tableElement.DataTable({
            language: {
              paginate: {
                previous: '<i class="fa fa-chevron-left"></i>', // Custom icon for previous button
                next: '<i class="fa fa-chevron-right"></i>', // Custom icon for next button
              },
            },
            dom: 'Bfrtip',
            buttons: [  
            'colvis',
            'pageLength', 
            {
              extend: 'csv',
              text: 'Export CSV',
              className: 'btn btn-primary',
              exportOptions: {
                columns: ':visible', 
              },
            },
            {
                extend: 'pdfHtml5',
                text: 'Export PDF',
                className: 'btn btn-primary',
                orientation: 'portrait', 
                exportOptions: {
                  columns: ':visible', 
                },
                customize: this.customizePDF
            },
          ],
            data: this.processedData,
            columns: [
              { data: null },
              { data: 'createdAt' },
              { data: 'productName' }, 
              { data: 'quantity' }, 
              { data: 'userName' }, 
              { data: 'approveDate'},
              { data: 'warehouse' }, 
              { data: 'action', render: this.renderActionButtons }
            ],
            columnDefs: [
              {
                targets: 0,
                searchable: false,
                orderable: false,
                render: (data, type, row, meta) => {
                  return meta.row + 1;
                },
              },
            ],
          });
        } catch(error){
          //console.log({error})
        }
      },

      renderActionButtons(data, type, row) {
        if (type === 'display') {
          let action = ''

          if (row.statusRow == 'active') {
            if(row.requesterId == this.userId)
              action += `<button class="small btn-style" onClick="openModal(${row.itemId}, ${row.requesterId})">Release Stock</button>`;
            else 
              action += `<button class="small btn-style" onClick="openModal(${row.itemId}, ${row.requesterId})">Request Release</button>`;
          } else if (row.statusRow == 'pending') {
            action += '<button class="btn btn-sm btn-warning">Pending Approval</button>';
          } 
          else if (row.statusRow == 'completed') {
            action += '<button class="btn btn-sm btn-success">Completed</button>';
          } else if (row.statusRow == 'rejected') {
            action += '<button class="btn btn-sm btn-danger">Rejected</button>';
          }
          
          action += `<a class="btn btn-sm btn-default" style="border: 1px solid black; margin-left: 15px;" href="/inventory/stocks/reserveds/${row.itemId}">Activity</a>`;
          
          return action;
        }
        return data;
      },
      


      customizePDF(doc) {
      //const logoBase64 = this.convertToBase64(logo)
      //console.log(logoBase64)

      const profile = JSON.parse(localStorage.getItem('profile'))
      doc.pageMargins = [40, 40, 40, 40]; // Set margins for the entire page
      doc.defaultStyle.columnGap = 0
      doc.content[1].fillColor = '#ffffff'

      doc.header = () => {
        return {
          columns: [
            {
              width: '*',
              columns: [
                /* {
                     image: logoBase64,
                     width: 150, // Adjust the width as needed
                 },*/
                {
                  text: profile?.businessName,
                  alignment: 'left',
                  margin: [40, 15, 0, 40], // Adjust margins as needed
                  color: '#FFA500', // Orange color
                  bold: true,
                  fontSize: 14,

                }
              ]
            },
            {
              width: '*',
              stack: [
                {
                  text: 'Stock Reserveds',
                  alignment: 'right',
                  margin: [0, 15, 50, 0],
                  fontSize: 12,
                  color: '#000000'
                },
                {  
                  alignment: 'right',
                  margin: [300, 0, 0, 0],
                  width: '*',
                  columns: [
                    {
                      width: 'auto',
                      text: 'Date:',
                      alignment: 'right',
                      margin: [0, 0, 10, 0],
                      bold: true,
                    },
                    {
                      width: 'auto',
                      text: `${this.formatDate(new Date(), "true")}`,
                      alignment: 'right',
                      margin: [0, 0, 50, 0],
                      fontSize: 9
                    }
                  ]
                }
              ]
            }
          ],
          fillColor: '#000000'
        };
      },

      doc.footer = (currentPage, pageCount) => docFooter(currentPage, pageCount)

      doc.styles.title = {
        color: '#000000',
        fontSize: 13,
        margin: [80, 0, 0, 40],
      };
    },









      convertDate(dateString) {
        const parts = dateString.split("/")
        const newDate = `${parts[1]}/${parts[0]}/${parts[2]}`;
        return newDate;
      },


      filterTable() {
        if (!this.dateFrom || !this.dateTo) {
          console.error("Invalid date inputs");
          return;
        }

        const fromDate = new Date(this.dateFrom);
        const toDate = new Date(this.dateTo);

        if (isNaN(fromDate) || isNaN(toDate)) {
          console.error("Invalid date values");
          return;
        }

        $.fn.dataTable.ext.search.push((settings, data, dataIndex) => {
          const dateStr = data[1]; 
          const parsedDate = this.convertDate(dateStr);
          const date = new Date(parsedDate);
          //console.log(settings)
          console.log(dataIndex)
          if (!isNaN(date)) {
           // console.log("From Date", fromDate)
           // console.log("Date", date)
           // console.log("To Date", toDate)

            return date >= fromDate && date <= toDate;
          }
          return false;
        });
        this.dataTable.draw();
        $.fn.dataTable.ext.search.pop();
      },

    











      async getActivities () {
            const requestOptions = {
                method: "GET",
                headers: { "Content-Type": "application/json", 'Authorization': 'Bearer '+this.token },
            };

            try{
              this.loading = true
              const res = await fetch(process.env.VUE_APP_URL+'/stockreserved', requestOptions)
              const data = await res.json()
              if(data.status == true){
                  this.activities = data.stocks
                  this.activitiesDatas = this.activities
                  this.processedData = this.preprocessData(data.stocks);
              }
            }catch(err){
              // console.log(err)
            }finally{
                this.loading = false
                // Wait for DOM to update (table to become visible) before initializing DataTable
                this.$nextTick(() => {
                  if (this.dataTable) {
                    this.dataTable.destroy();
                    this.dataTable = null;
                  }
                  this.initializeDataTable();
                });
            }
        },
        async confirmRelease() {
          const requestOptions = {
              method: "POST",
              headers: { "Content-Type": "application/json", 'Authorization': 'Bearer '+this.token },
              body: JSON.stringify({ 
                quantity: this.quantity,
                priority: this.priority,
                comment: this.comment,
                reservedId: this.reservedId,
              })
          };
          const res = await fetch(process.env.VUE_APP_URL+'/stockreserved/release', requestOptions)
          const data = await res.json()
          if(data.status == true){
            Swal.fire({
                position: 'top-center',
                icon: 'success',
                title: 'Stock Release Requested',
                showConfirmButton: false,
                timer: 1500
              })
              window.location.reload()       
          }else{
            Swal.fire({
                icon: 'error',
                title: 'Stock Release not requested',
                text: data.message
            })
          }
        }
    }
  }
</script>


<style lang="scss" scoped>
  $text-color: #000000;
  $primary: #d2d2d2;
  $green: #000000;
  $white: #ffffff;
  select {
    /* inline SVG */
    background: url("data:image/svg+xml;charset=US-ASCII,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20viewBox%3D%220%200%20256%20448%22%20enable-background%3D%22new%200%200%20256%20448%22%3E%3Cstyle%20type%3D%22text%2Fcss%22%3E.arrow%7Bfill%3A%23424242%3B%7D%3C%2Fstyle%3E%3Cpath%20class%3D%22arrow%22%20d%3D%22M255.9%20168c0-4.2-1.6-7.9-4.8-11.2-3.2-3.2-6.9-4.8-11.2-4.8H16c-4.2%200-7.9%201.6-11.2%204.8S0%20163.8%200%20168c0%204.4%201.6%208.2%204.8%2011.4l112%20112c3.1%203.1%206.8%204.6%2011.2%204.6%204.4%200%208.2-1.5%2011.4-4.6l112-112c3-3.2%204.5-7%204.5-11.4z%22%2F%3E%3C%2Fsvg%3E%0A"), #fff;
    background-position: right 10px center;
    background-repeat: no-repeat;
    background-size: auto 50%;
    border-radius: 3px;
    height: 40px;
    border: 1px solid #b4c7e7 !important;
    padding: 5px 30px 5px 10px;
    // disable default appearance
    outline: none;
    -moz-appearance: none;
    -webkit-appearance: none;
    appearance: none;
    &::-ms-expand { display: none };
    &.full{
      width: 100%;
    }
    &:focus, &:hover{
      background: url("data:image/svg+xml;charset=US-ASCII,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20viewBox%3D%220%200%20256%20448%22%20enable-background%3D%22new%200%200%20256%20448%22%3E%3Cstyle%20type%3D%22text%2Fcss%22%3E.arrow%7Bfill%3A%23424242%3B%7D%3C%2Fstyle%3E%3Cpath%20class%3D%22arrow%22%20d%3D%22M255.9%20168c0-4.2-1.6-7.9-4.8-11.2-3.2-3.2-6.9-4.8-11.2-4.8H16c-4.2%200-7.9%201.6-11.2%204.8S0%20163.8%200%20168c0%204.4%201.6%208.2%204.8%2011.4l112%20112c3.1%203.1%206.8%204.6%2011.2%204.6%204.4%200%208.2-1.5%2011.4-4.6l112-112c3-3.2%204.5-7%204.5-11.4z%22%2F%3E%3C%2Fsvg%3E%0A"), #fff;
      border: 1px solid $text-color;
      background-position: right 10px center;
      background-repeat: no-repeat;
      background-size: auto 50%;
    }
  }

 
  .check-button{
        display: flex;
        align-items: center;
        gap: 10px;
      }
      .form-group{
        .components-button {
          display: flex;
          align-items: center;
          justify-content: left;
          span.switcher {
            position: relative;
            width: 156px;
            height: 56px;
            border-radius: 10px;
            input {
              appearance: none;
              position: relative;
              width: 130px;
              height: 40px;
              border-radius: 3px;
              border-color: #d2d2d2 !important;
              background: $primary;
              outline: none;
              font-family: 'Oswald', sans-serif;
              &:before, &:after {
                z-index: 2;
                position: absolute;
                top: 50%;
                transform: translateY(-50%);
                color: $white;
              }
              &:before {
                content: 'Yes';
                left: 13px;
                font-weight: 600;
                font-size: 13px;
                line-height: 33px;
                color: #FFFFFF;
              }
              &:after {
                content: 'No';
                right: 13px;
                font-weight: 600;
                font-size: 17px;
                line-height: 33px;
                color: #FFFFFF;
              }
            }
            label {
              z-index: 1;
              position: absolute;
              width: 55px;
              height: 32px;
              margin: 0;
              top: 4px;
              left: 71px !important;
              border-radius: 3px;
            }
            &.switcher-1, &.switcher-2 {
              input {
                transition: .25s -.1s;
                &:checked {
                  background: $primary;
                  &:before {
                    color: $white;
                    transition: color .5s .2s;
                  }
                  &:after {
                    color: #ffffff;
                    transition: color .5s;
                  }
                  & + label {
                    left: 4px !important;
                    background: $green;
                    transition: left .5s, right .4s .2s;
                    height: 30px !important;
                  }
                }
                &:not(:checked) {
                  background: $primary;
                  transition: background .5s -.1s;
                  &:before {
                    color: #ffffff;
                    transition: color .5s;
                  }
                  &:after {
                    color: $white;
                    transition: color .5s .2s;
                  }
                  & + label {
                    left: 100px;
                    right: 10px;
                    background: $green;
                    height: 30px !important;
                    transition: left .4s .2s, right .5s, background .35s -.1s;
                  }
                }
              }
            }
          }
        }
      }

</style>